import './index.scss'
$("header").addClass("head1")
$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$(".nav li").hover(function(){
    $(".navchild").css("display","none");
    // $(".header-bg").css("opacity","1")
    $(".header-bg").css("display","block");
    $(this).find(".navchild").css("display","flex");
})
$("header").hover(function(){

},function(){
    // $(".header-bg").css("opacity","0")
    $(".header-bg").css("display","none");
    $(".navchild").css("display","none");
})
$(".header-bg").hover(function(){

},function(){
    // $(".header-bg").css("opacity","0")
    $(".header-bg").css("display","none");
    $(".navchild").css("display","none");
})
$(".nav li:first").hover(function(){
    // $(".header-bg").css("opacity","0")
    $(".header-bg").css("display","none");
})
$(".nav li:nth-child(2)").hover(function(){
    // $(".header-bg").css("opacity","0")
    $(".header-bg").css("display","none");
})

$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})
$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            // alert($("#slideBox").height());
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})
